module.exports = __webpack_public_path__ + "img/implementation.e4e3db8c.svg";